import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useStore } from '@hmpu/powerups.store';
import { CTAButton } from '@hmpu/powerups.ui.buttons.cta-button';
import HeaderH1 from '../Promo';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
// import useSoundEffects from '@hmpu/powerups.audio.hooks.use-sound-effects';  // TODO: prolly sound fx on this button;
import { SelectionButton } from '../../components/SelectionButton';
import type { GoToPrevPage, GoToNextPage } from "@hmpu/powerups.config.page.provider";
import { useEffect, useState } from 'react';
import { globalizedMedia } from '@hmpu/powerups.intl.hooks.use-localized-media';

import './SelectionPageContent.css';
import useResetFocus from '../../hooks/useResetFocus';


export type SelectionPageContentProps = {
  goToPrevPage: GoToPrevPage;
  goToNextPage: GoToNextPage;
  parentNode: string;
}

export function SelectionPageContent(props: SelectionPageContentProps) {

  console.log('SelectionPageContent props', props);

  /* eslint-disable-next-line no-unused-vars */
  const { goToPrevPage, goToNextPage, parentNode } = props;

  const { __t } = useTranslation(parentNode);
  const bgImg = __t('bgImg', parentNode);
  const bgGradient = __t("bgGradient", parentNode);
  const classPrefix = __t('classPrefix');
  const entityStateKey = __t('entityStateKey');
  const entitySetStateKey = __t('entitySetStateKey');
  const entityType = __t('entityType');
  const entities = __t(entityType);
  const lineDrip = __t('lineDrip');
  const ctaButtons = __t('ctaButtons');
  const translate = useTranslate();

  const viewport = useStore((state) => state.viewport);
  const entity = useStore((state) => state[entityStateKey]);
  const setTargetValue = useStore((state) => state[entitySetStateKey]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const warningTextBg = globalizedMedia(translate('warningHeaderBg', parentNode), 'img');

  const levels = __t('levels', 'LEVEL_SELECTION');

  useEffect(() => {
    console.log(JSON.stringify(levels));
  }, [])
 
  return (
    <section className={`level-selection-page`}>
      <div
        className="bgRadialGradient"
        style={{
          background: `url(${bgGradient}) no-repeat 50% 50%`,
          backgroundSize: "cover",
        }}
      ></div>
      <div className="level-selection-copy" 
      style={{
        // height: `${viewport.height}px`,
      }}>
        {/* <div className="level-selection-header">
          <h1 className='HeaderH1'>{__t('h1')}</h1>
        </div> */}

        {/* <div className="disclaimer-header level-select-header" style={{
          width: "80%",
          margin: "0 auto",
          background: `url(${warningTextBg}) no-repeat 50% 50%`,
          backgroundSize: "contain"
        }}>
        </div> */}

        <HeaderH1 ariaHidden={false} textValue={__t('h1')} animate={false} />

        <nav className={`selection-nav`}>
          <ul className={`selection-list`}>
            {entities.map((entity: any, index: number) => (
              <li key={entity.slug} className={`selection-list-item`}>
                <SelectionButton
                  positionIndex={index} 
                  slug={entity.slug}
                  label={entity.label}
                  ariaLabel={entity.ariaLabel}
                  selectionImage={entity.bgImg}
                  selectionCard={entity.selectionCard}
                  setTargetValue={setTargetValue}
                  lineDrip={lineDrip}
                  setIsButtonDisabled={setIsButtonDisabled}
                  goToNextPage={goToNextPage}
                />
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
}